//COMPANY
import {CREATE_COMPANY, LIST_COMPANIES, STORE_COMPANIES, UPDATE_COMPANY} from "../../constants/settings";

export const listCompanies = () => ({
    type: LIST_COMPANIES
})


export const createCompany = (company, refresh) => ({
    type: CREATE_COMPANY,
    company,
    refresh
})

export const updateCompany = (updatedCompany) => ({
    type: UPDATE_COMPANY,
    updatedCompany
})

export const storeCompanies = (companies) => ({
    type: STORE_COMPANIES,
    companies
})